import { useState, useCallback } from "react"
import { fetchDuplicateClusters, mergeLeads } from "../api/duplicatesApi"

// ── useDuplicateClusters ──────────────────────────────────────────────────────
// Loads grouped duplicate clusters for the org. Mirrors the useLeads pattern.
export function useDuplicateClusters() {
  const [clusters, setClusters] = useState([])
  const [meta, setMeta]         = useState(null)
  const [loading, setLoading]   = useState(false)
  const [error, setError]       = useState(null)

  const fetch = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await fetchDuplicateClusters()
      setClusters(data.clusters ?? [])
      setMeta(data.meta ?? null)
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  return { clusters, meta, loading, error, fetch, refresh: fetch }
}

// ── useMergeLeads ─────────────────────────────────────────────────────────────
export function useMergeLeads() {
  const [status, setStatus] = useState("idle")
  const [error, setError]   = useState(null)

  const mutate = useCallback(async ({ primaryId, duplicateIds }) => {
    setStatus("pending")
    setError(null)
    try {
      const result = await mergeLeads({ primaryId, duplicateIds })
      setStatus("success")
      return result
    } catch (err) {
      const msg = err.response?.data?.errors || [err.message || "Failed to merge leads"]
      setError(msg)
      setStatus("error")
      throw msg
    }
  }, [])

  return {
    mutate,
    status,
    error,
    isPending: status === "pending",
    reset: () => { setStatus("idle"); setError(null) },
  }
}
